import { action, observable } from 'mobx'
import { validationContext } from 'validx'
import { FilterEditorViewModelBase } from '@/features/legends/filters/FilterEditorViewModelBase'
import type { ExpressionRule } from '@/features/legends/filters/rules'

/**
 * A Ryno formula that resolves to a yes/no. Hidden from the add menu, but
 * older legends still have them.
 */
export class ExpressionEditorViewModel extends FilterEditorViewModelBase<ExpressionRule> {
  readonly type = 'Expression'

  @observable accessor expr = ''

  /**
   * The formula as typed. It becomes the formula once committed, so typing
   * doesn't change the legend on every keystroke.
   */
  @observable accessor exprDraft = ''

  readonly validation = validationContext(this, {})

  /**
   * Sets the formula as typed.
   */
  @action.bound
  setExprDraft(expr: string) {
    this.exprDraft = expr
  }

  /**
   * Sets the formula from the draft.
   */
  @action.bound
  commitExpr() {
    this.expr = this.exprDraft
  }

  /** @inheritDoc */
  @action
  hydrate({ expr }: ExpressionRule) {
    this.expr = expr ?? ''
    this.exprDraft = this.expr
  }

  /** @inheritDoc */
  toJSON(): ExpressionRule {
    return { type: this.type, expr: this.expr }
  }
}
